import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Sagient Partners</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #0C447C 0%, #0A1628 100%)',
        padding: '80px 0 72px',
        color: '#fff',
        textAlign: 'center',
      }}>
        <div className="container">
          <p style={{ fontSize: '5rem', fontWeight: 800, color: '#378ADD', lineHeight: 1, marginBottom: 16 }}>404</p>
          <h1 style={{ color: '#fff', marginBottom: 16 }}>Page Not Found</h1>
          <p style={{ color: '#B5D4F4', fontSize: '1.1rem', maxWidth: 480, margin: '0 auto 40px' }}>
            The page you're looking for doesn't exist or may have moved.
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-white">Go to Homepage</Link>
            <Link to="/services" className="btn btn-outline" style={{ borderColor: '#B5D4F4', color: '#B5D4F4' }}>
              View Services →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
